// src/index.ts
import { Color } from "@tiptap/extension-text-style";
var index_default = Color;
export {
  Color,
  index_default as default
};
//# sourceMappingURL=index.js.map